import { useSyncExternalStore } from "react";
import {
  getAdminFactionState,
  subscribeAdminFaction,
  type AdminFactionState,
} from "@/lib/adminFaction";

/** Subscribe to the service-admin "view as" override store. */
export function useAdminFaction(): AdminFactionState {
  return useSyncExternalStore(
    subscribeAdminFaction,
    getAdminFactionState,
    getAdminFactionState,
  );
}
